const pricingDataFaqs = [
    {
        id:"1",
        question : "What Is M Power Moving Services’ Pricing Model?",
        answer :"We calculate your moving price based on several factors, including:",
        points:[
            "The average volume of items/inventory list provided by the client",
            "The distance between pickup and destination locations",
            "Any special moving requirements",
            "Accessibility for the moving truck",
            "The date and time of the move",
        ]
    },
    {
        id:"2",
        question : "How Many Hours Are Included in a Flat Fee?",
        answer :"The number of hours depends on the size of your move. Your moving crew may consist of 2, 3, 4, or even 5 movers. For a one- or two-bedroom apartment, a 3-person crew is the most common. If needed, we can arrange for a larger team upon request.",
        points : [

        ]
    },
    {
        id:"3",
        question : "Does M Power Moving Services Include the Cost of Boxes, Packing Supplies, and Packing in the Moving Price?",
        answer :"As part of our standard service, we provide boxes for your hanging clothes, TVs, mirrors, and picture frames. However, personal belongings that fit in standard-sized boxes will need to be packed by you. If you prefer a hassle-free move, we offer an upgraded package that includes professional packers and all necessary packing supplies.",
        points : [
            
        ]
    },
    {
        id:"4",
        question : "Do You Charge Extra for Buildings with Stairs?",
        answer :"No surprises! The number of flights of stairs is noted in your contract and already included in the all-inclusive price confirmed with our moving consultants.",
        points : [
            
        ]
    },
]

export default pricingDataFaqs;